import { render, staticRenderFns } from "./SiteModal.vue?vue&type=template&id=b0485f34"
import script from "./SiteModal.vue?vue&type=script&lang=ts"
export * from "./SiteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports